// extracted by mini-css-extract-plugin
export var avatarContainer = "_co-0";
export var avatarTypingWave = "_co-i";
export var gray = "_co-f";
export var green = "_co-c";
export var icon = "_co-9";
export var image = "_co-1";
export var lg = "_co-6";
export var md = "_co-5";
export var presenceDot = "_co-b";
export var red = "_co-d";
export var sm = "_co-4";
export var status = "_co-a";
export var typingDot = "_co-h";
export var typingPill = "_co-g";
export var xl = "_co-7";
export var xs = "_co-3";
export var xxl = "_co-8";
export var xxs = "_co-2";
export var yellow = "_co-e";